import { FiSearch } from 'react-icons/fi';
import './styles.css';
import { useState } from 'react';
import api from './services/api'

function App() {
  
  const [ input, setInput ] = useState();
  const [ cep, setCep ] = useState({})

  async function handleSearch() {
    if(input === '') {
      alert("Informe o CEP!");
    }
    try {
      const response = await api.get(`${input}/json/`)
      // console.log(response.data)
      setCep(response.data)
    } catch (err){
      alert('Ops! deu errado. '+ err)
      setInput('')
    }
  }

  return (
    <div className="container">
      <h1 className="title">Busca CEP</h1>
      
      <div className="containerInput">
        <input 
          value={input} 
          onChange={(e) => {setInput(e.target.value)}} 
          type="text" 
          placeholder="Digite seu CEP ..."
        />
        <button className='buttonSearch' onClick={handleSearch}>
          <FiSearch size={25} color='#ffffff'/>
        </button>
      </div>
      { Object.keys(cep).length > 0 && (
        <main className='main'>
          <h2>CEP: {cep.cep}</h2>
          <span>Logradouro: {cep.logradouro}</span>
          <span>Complemento: {cep.complemento}</span>
          <span>Bairro: {cep.bairro}</span>
          <span>Cidade: {cep.localidade}</span>
          <span>Estado: {cep.uf}</span>
        </main>
      )}
      
    </div>
  );
}

export default App;
